import {Fragment, useEffect, useState} from "react";
import {Dialog, Transition} from "@headlessui/react";
import {getCookie, setCookie} from "./index";
import Action from "../../components/action";
import classNames from "classnames";
import {textAlignment} from "../../utils/block-utils";

export default function Design1({
                                    modalId,
                                    title,
                                    message,
                                    cookie = false,
                                    cookieDays = 30,
                                    onClose,
                                    actions,
                                    ...props
                                }) {
    const [isOpen, setIsOpen] = useState(false);
    const id = modalId;

    useEffect(() => {
        if (cookie) {
            const seen = getCookie(`popUp_${id}`);
            if (!seen) {
                setIsOpen(true);
                setCookie(`popUp_${id}`, "true", cookieDays);
            }
        } else {
            setIsOpen(true);
        }
    }, [id, cookie, cookieDays]);

    const handleClose = () => {
        setIsOpen(false);
        onClose?.();
    };
    
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10 popup-design-1" onClose={handleClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-200"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/30"/>
                </Transition.Child>

                <div className="fixed inset-0 flex items-center justify-center p-4">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <div className="absolute top-[calc(var(--site-nav-height)+64px)] w-[92%]">
                            <Dialog.Panel
                                className="bg-white rounded-theme shadow-lg w-full mx-auto p-6 max-h-[75vh] overflow-y-auto sm:w-[38rem] w-full">
                                <Dialog.Title
                                    as="h5"
                                    className="text-center text-gray-900 !mb-4"
                                    dangerouslySetInnerHTML={{__html: title}}
                                />
                                <div
                                    className={classNames("rich-text", textAlignment(props))}
                                    dangerouslySetInnerHTML={{__html: message}}
                                />
                                {actions &&
                                    <div className="sm:space-x-2 space-y-2 sm:space-y-0 mt-6 text-center">
                                        {actions.map((action, i) => {
                                            return (<Action key={i} className={"sm:w-auto w-full justify-center"} {...action} title={null}/>)
                                        })}
                                    </div>
                                }
                            </Dialog.Panel>
                            <button
                                onClick={handleClose}
                                className="absolute mt-4 mx-auto left-1/2 transform -translate-x-1/2 border-2 border-gray-300 bg-white rounded-full shadow-lg overflow-hidden">
                                <svg
                                    className="h-8 w-8 stroke-gray-800 bg-gray-100 p-1"
                                    fill="none"
                                    viewBox="0 0 24 24">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
}